export const ru = {
    nav: {
        dashboard: 'Панель управления',
        board: 'Доска',
        list: 'Список',
        settings: 'Настройки',
        reports: 'Отчёты',
        myTasks: 'Мои задачи',
        activity: 'Активность',
        charts: 'Диаграммы',
        team: 'Команда',
        timeTracking: 'Учёт времени',
        admin: 'Админ',
        adminOverview: 'Обзор админа',
        userManagement: 'Управление пользователями',
        projectSetup: 'Настройка проекта',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Управление проектами на Markdown',
        version: 'Версия',
        back: 'Назад',
        loading: 'Загрузка...',
        noData: 'Нет данных',
        search: 'Поиск',
        filter: 'Фильтр',
        all: 'Все',
        close: 'Закрыть',
        open: 'Открыть',
        connect: 'Подключить',
        archived: 'Архивировано',
        inactive: 'Неактивно',
        active: 'Активно',
        untitled: 'Без названия',
        unknown: 'Неизвестно',
        tasks: 'Задачи',
        done: 'Готово',
        lastModified: 'Последнее изменение',
        created: 'Создано',
        points: 'Очки',
        pts: 'очк.',
        yes: 'Да',
        no: 'Нет',
        or: 'или',
    },
    actions: {
        create: 'Создать',
        edit: 'Редактировать',
        delete: 'Удалить',
        save: 'Сохранить',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        add: 'Добавить',
        remove: 'Удалить',
        update: 'Обновить',
        close: 'Закрыть',
        submit: 'Отправить',
        reset: 'Сбросить',
        load: 'Загрузить',
        export: 'Экспорт',
        import: 'Импорт',
        archive: 'Архивировать',
        restore: 'Восстановить',
        deactivate: 'Деактивировать',
        activate: 'Активировать',
    },
    auth: {
        signIn: 'Войти',
        signOut: 'Выйти',
        signUp: 'Зарегистрироваться',
        username: 'Имя пользователя',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        displayName: 'Отображаемое имя',
        email: 'Электронная почта',
        role: 'Роль',
        createAccount: 'Создать аккаунт',
        dontHaveAccount: 'Нет аккаунта?',
        alreadyHaveAccount: 'Уже есть аккаунт?',
        signInToAccount: 'Войдите в свой аккаунт',
        createYourAccount: 'Создайте свой аккаунт',
        enterUsername: 'Введите имя пользователя',
        enterPassword: 'Введите пароль',
        chooseUsername: 'Выберите имя пользователя',
        yourFullName: 'Ваше полное имя',
        atLeast6Chars: 'Минимум 6 символов',
        confirmPasswordPlaceholder: 'Подтвердите пароль',
        pleaseEnterCredentials: 'Пожалуйста, введите имя пользователя и пароль',
        invalidCredentials: 'Неверное имя пользователя или пароль',
        pleaseFillAllFields: 'Пожалуйста, заполните все поля',
        passwordsDoNotMatch: 'Пароли не совпадают',
        passwordTooShort: 'Пароль должен содержать минимум 6 символов',
        usernameExists: 'Имя пользователя уже существует',
        demoCredentials: 'Демо-учетные данные',
        admin: 'Администратор',
        manager: 'Менеджер',
        developer: 'Разработчик',
        viewer: 'Наблюдатель',
        contactAdminForRole: 'Свяжитесь с администратором для изменения роли',
        usernameCannotBeChanged: 'Имя пользователя нельзя изменить',
    },
    statuses: {
        backlog: 'Бэклог',
        todo: 'К выполнению',
        inProgress: 'В работе',
        inReview: 'На проверке',
        done: 'Готово',
        planned: 'Запланировано',
        inProgressSprint: 'В работе (спринт)',
        completed: 'Завершено',
        allStatus: 'Все статусы',
    },
    priorities: {
        critical: 'Критический',
        high: 'Высокий',
        medium: 'Средний',
        low: 'Низкий',
    },
    messages: {
        noProjects: 'Проектов пока нет',
        noTasks: 'Нет задач',
        confirmDelete: 'Вы уверены, что хотите удалить это?',
        saved: 'Успешно сохранено',
        error: 'Произошла ошибка',
        noTasksAssigned: 'Вам не назначено задач',
        noActivityYet: 'Активности пока нет',
        confirmReset: 'Все данные будут сброшены до начального состояния. Продолжить?',
        removeUserConfirm: 'Вы уверены, что хотите удалить этого пользователя?',
        deleteProjectConfirm: 'Вы уверены, что хотите удалить этот проект?',
        archiveProjectConfirm: 'Вы уверены, что хотите архивировать этот проект?',
    },
    settings: {
        title: 'Настройки',
        theme: 'Тема',
        language: 'Язык',
        languageAndRegion: 'Язык и регион',
        gitConfig: 'Настройки Git',
        gitIntegration: 'Интеграция с Git',
        gitProvider: 'Провайдер Git',
        repositoryUrl: 'URL репозитория',
        seedData: 'Тестовые данные',
        seedDataDescription: 'Загрузите примеры проектов с задачами, спринтами и эпиками для тестирования. Все данные будут сброшены.',
        loadSeedData: 'Загрузить тестовые данные',
        seedDataConfirm: 'Все данные будут сброшены до начального состояния. Продолжить?',
        appearance: 'Внешний вид',
        notifications: 'Уведомления',
    },
    themes: {
        summer: 'Лето',
        spring: 'Весна',
        autumn: 'Осень',
        winter: 'Зима',
        day: 'День',
        night: 'Ночь',
        summerDay: 'Летний день',
        summerNight: 'Летняя ночь',
        springDay: 'Весенний день',
        springNight: 'Весенняя ночь',
        autumnDay: 'Осенний день',
        autumnNight: 'Осенняя ночь',
        winterDay: 'Зимний день',
        winterNight: 'Зимняя ночь',
        highContrast: 'Высокий контраст',
        selectTheme: 'Выберите тему',
    },
    time: {
        hours: 'часов',
        minutes: 'минут',
        days: 'дней',
        weeks: 'недель',
        justNow: 'только что',
        minutesAgo: '{{count}} мин. назад',
        hoursAgo: '{{count}} ч. назад',
        daysAgo: '{{count}} дн. назад',
        updatedAt: 'Обновлено',
    },
    reports: {
        velocity: 'Скорость',
        burndown: 'Диаграмма сгорания',
        burnup: 'Диаграмма прироста',
        cycleTime: 'Время цикла',
        leadTime: 'Время выполнения',
        throughput: 'Производительность',
        gantt: 'Диаграмма Ганта',
        cumulativeFlow: 'Кумулятивный поток',
    },
    globalSearch: {
        placeholder: 'Поиск проектов, задач, спринтов...',
        noResults: 'Результаты не найдены',
        projects: 'Проекты',
        tasks: 'Задачи',
        sprints: 'Спринты',
        epics: 'Эпики',
    },
    notifications: {
        title: 'Уведомления',
        markAllRead: 'Отметить все как прочитанные',
        clearAll: 'Очистить все',
        empty: 'Нет уведомлений',
        unread: '{count} непрочитанных',
    },
    dashboard: {
        totalProjects: 'Всего проектов',
        totalTasks: 'Всего задач',
        completion: 'Выполнение',
        statusBreakdown: 'Разбивка по статусам',
        createProject: 'Создать проект',
        loadSeedData: 'Загрузить примеры данных',
        noProjects: 'Проектов пока нет',
        getStarted: 'Начните с создания нового проекта или загрузки примеров данных.',
        projects: 'Проекты',
        newProject: 'Новый проект',
        createNewProject: 'Создать новый проект',
        projectName: 'Название проекта',
        description: 'Описание',
        workflow: 'Рабочий процесс',
        skipToMain: 'Перейти к основному содержимому',
        projectProgress: 'Прогресс проекта',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Джалали',
        hijri: 'Хиджри',
        gregorian: 'Григорианский',
    },
    accessibility: {
        skipToMain: 'Перейти к основному содержимому',
        board: 'Доска задач',
        projectList: 'Список проектов',
        mainNav: 'Основная навигация',
        selectTheme: 'Выберите тему',
        projectDashboard: 'Панель проекта',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Доска',
        kanban: 'Канбан',
        scrum: 'Скрам',
    },
    task: {
        title: 'Задача',
        createTask: 'Создать задачу',
        editTask: 'Редактировать задачу',
        deleteTask: 'Удалить задачу',
        assignee: 'Исполнитель',
        unassigned: 'Без исполнителя',
        storyPoints: 'Story-очки',
        labels: 'Метки',
        description: 'Описание',
        acceptanceCriteria: 'Критерии приёмки',
        timeLog: 'Журнал времени',
        comments: 'Комментарии',
        addComment: 'Добавить комментарий',
        noComments: 'Комментариев пока нет',
        status: 'Статус',
        priority: 'Приоритет',
        created: 'Создано',
        updated: 'Обновлено',
        started: 'Начато',
    },
    sprint: {
        title: 'Спринт',
        createSprint: 'Создать спринт',
        sprintGoal: 'Цель спринта',
        committedPoints: 'Взято очков',
        completedPoints: 'Завершено очков',
        velocity: 'Скорость',
        planned: 'Запланировано',
        inProgress: 'В работе',
        completed: 'Завершено',
    },
    team: {
        title: 'Команда',
        members: 'Участники',
        role: 'Роль',
        availability: 'Доступность',
        assignedTasks: 'Назначенные задачи',
        activeTasks: 'Активные задачи',
        doneTasks: 'Завершённые задачи',
    },
    timeTracking: {
        title: 'Учёт времени',
        timer: 'Таймер',
        manualEntry: 'Ручной ввод',
        startTime: 'Время начала',
        stopTime: 'Время окончания',
        duration: 'Длительность',
        date: 'Дата',
        totalHours: 'Всего часов',
        entries: 'Записи',
        noEntries: 'Записей пока нет',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Панель администратора',
        projects: 'Проекты',
        totalTasks: 'Всего задач',
        storyPoints: 'Story-очки',
        taskStatusBreakdown: 'Разбивка задач по статусам',
        projectProgress: 'Прогресс проекта',
        teamWorkload: 'Нагрузка команды',
        assigned: 'Назначено',
        active: 'Активно',
    },
    myTasks: {
        title: 'Мои задачи',
        total: 'Всего',
        inProgress: 'В работе',
        inReview: 'На проверке',
        done: 'Готово',
        completion: 'Выполнение',
        allStatus: 'Все статусы',
        allProjects: 'Все проекты',
        noTasksAssigned: 'Вам не назначено задач',
    },
    activity: {
        title: 'Лента активности',
        commentsOnYourTasks: 'Комментарии к вашим задачам',
        allActivity: 'Вся активность',
        noActivityYet: 'Активности пока нет',
        commentedOn: 'прокомментировал(а)',
        movedTo: 'переместил(а) в',
    },
    profile: {
        title: 'Профиль',
        avatar: 'Аватар',
        dragDropImage: 'Перетащите изображение сюда или выберите файл',
        browse: 'Обзор',
        imageFormats: 'PNG, JPG, WEBP до 2 МБ',
        removePhoto: 'Удалить фото',
        saveChanges: 'Сохранить изменения',
        profileSaved: 'Профиль сохранён',
        contactAdmin: 'Свяжитесь с администратором для изменения роли',
    },
};
//# sourceMappingURL=ru.js.map